import { Table } from "antd";
import { useState } from 'react';
const columns=[
    {
        title:"Id",
        dataIndex:'id',
        key:'id'
    },
    {
        title:"Name",
        dataIndex:'name',
        key:'name'
    },
    {
        title:"Phone Number",
        dataIndex:'phoneNumber',
        key:'phoneNumber'
    },
    {
        title:"Account Number",
        dataIndex:'accountNumber',
        key:'accountNumber'
    }
]
const Customers=()=>{
    const [data,setData]=useState([])
    return  (
        <div>
            <Table columns={columns} dataSource={data}/>
        </div>
    )
};
export default Customers;